import _ from 'lodash'
import axios from 'axios'
import ModaleGauche from '../../modals/modale_gauche.vue'
import LoadingBtn from '../../../common/ui/loading_btn.vue'
import FieldAdresse from '../../maps/field_adresse.vue'
import CustomInput from '../../../common/forms/Input.vue'
import DrawingModes from './drawing_modes.vue'
import Onglets from '../../../common/ui/onglets.vue'
import * as turf from '@turf/turf'
import Utils from '../../../common/utils.js'


export default {
	mixins: [Utils],
	data() {
		return {
			new_search: true,
			force_new_search: false,
			recherche_nom: '',
			loading: false,
			erreur: '',
			erreur_surface_grande: '',
			current_search: {},
			global_area_radius: 5,
			largeur_zone_capture: null, // Largeur en km de la zone de capture,
			onglets: [{
				code: 'zone',
				label: this.$t('rapport_zone_titre_zone_implantation_onglet_zone_tracee')
			}, {
				code: 'parcelles',
				label: this.$t('rapport_zone_titre_zone_implantation_onglet_parcelles')
			}],
			choice: 'zone'
		}
	},
	props: [],
	watch: {
		choice: {
			handler(newVal, oldVal){
				if(newVal === 'parcelles'){
					this.$store.commit('UI_SET_CLICK_ON_LAYER', true)
				}else{
					this.$store.commit('UI_SET_CLICK_ON_LAYER', false)
				}
			},
		},
		'$store.state.ui.map_bounds_report': {
			handler(newVal, oldVal){
				if(newVal.west !== oldVal.west || newVal.east !== oldVal.east || newVal.north !== oldVal.north){
					let surface_km2 = google.maps.geometry.spherical.computeArea(newVal)
					surface_km2 = (surface_km2 / 1000000).toFixed(2)
					if(surface_km2 > 40){
						this.erreur_surface_grande  = this.$t('rapport_zone_erreur_surface_grande');
					}else{
						this.erreur_surface_grande = '';
					}

					// Calcul de la largeur en km de la zone de capture (distance ouest-est)
					if(newVal && newVal.west !== undefined && newVal.east !== undefined && newVal.north !== undefined) {
						const westPoint = new google.maps.LatLng(newVal.north, newVal.west);
						const eastPoint = new google.maps.LatLng(newVal.north, newVal.east);
						this.largeur_zone_capture = google.maps.geometry.spherical.computeDistanceBetween(westPoint, eastPoint) / 1000;
					} else {
						this.largeur_zone_capture = 0;
					}
				}
			},
			deep: true
		}
	},
	created(){
		if(this.$store.state.ui.recherche && this.$store.state.ui.recherche.nom != '__last__'){
			this.new_search = false;
			this.recherche_nom = this.$store.state.ui.recherche.nom;
			this.current_search = _.cloneDeep(this.$store.state.ui.recherche);
			this.global_area_radius = this.$store.state.ui.recherche.area_report.global_area_radius || 5;
		}
		
	},
	mounted(){
		this.$store.commit('UI_SET_CLICK_ON_LAYER', false)
		this.$store.commit('PARCELLE_ONLY_MULTISELECTIONS', true)
		document.addEventListener('fullscreenchange', this.fullscreenchange)
	},
	destroyed(){
		this.$store.commit('UI_SET_CLICK_ON_LAYER', true)
		this.$store.commit('PARCELLE_ONLY_MULTISELECTIONS', false)
		document.removeEventListener('fullscreenchange', this.fullscreenchange)
	},
	methods: {
		toggle_global_area_radius(){
			this.global_area_radius = this.global_area_radius ? null : 5;
		},
		fullscreenchange(){
			if(!document.fullscreenElement){
				this.closeModale()
			}
		},
		switchSaveSearch(){
			this.force_new_search = !this.force_new_search;
			if(this.force_new_search){
				this.recherche_nom = '';
			}else{
				this.recherche_nom = '';
			}
		},
		generateReport(){
			this.saveSearch()
		},
		saveSearch(){
			var self = this;
			
			let map_bounds_report = self.$store.state.ui.map_bounds_report
			
			if(this.erreur_surface_grande != ''){
			}else if(!this.hasParcellesSelectedInArea){
			}else if(self.recherche_nom == ''){
				self.erreur  = self.$t('save_search_erreur');
				self.encours = false;
			}else if(!self.$store.getters.hasZoneImplantation && self.$store.getters.getSelectedParcellesIds.length === 0){
				self.erreur  = self.$t('rapport_zone_erreur_zone_implantation');
				self.encours = false;
			}else{
				self.erreur  = false;
				self.encours = true;
				self.succes  = false;
				self.loading = true

				let project_area = self.$store.getters.getProjectArea

				let area_report = {
					report_name: self.recherche_nom,
					capture_area: {
						type: "rectangle",
						fillColor: "#3861FB",
						fillOpacity: 0.4,
						strokeColor: "#3861FB",
						strokeOpacity: 1,
						strokeWeight: 3,
						bounds: map_bounds_report
					},
					global_area_radius: self.global_area_radius != null ? self.maxiGlobalRadius : self.global_area_radius	
				}

				if(this.$store.getters.getAnnotationsForSave.length > 0){
					area_report.project_area = project_area
				}else{
					let selected_parcelles_ids = self.$store.getters.getSelectedParcellesIds
					let parcels_list = [];
					selected_parcelles_ids.forEach(id => {
						parcels_list.push( {"identifiant": id, "strokeColor": '#FFC700', "strokeOpacity": 0.8, "strokeWeight": 3})
					})
					area_report.parcels_list = parcels_list
				}

				let recherche = {}

				//RZ--> Dans le cas d'un update
				if(!self.force_new_search && this.new_search == false){
					recherche             = self.current_search
					recherche.recherche   = self.$store.state.filters.filters
					recherche.layers      = self.$store.getters.getLayersToSave
					recherche.annotations = self.$store.getters.getAnnotationsForSave
					recherche.update      = true
					recherche.area_report = area_report

				//RZ--> Si on est sur un ajout
				}else{
					let email = self.$store.state.user.user.email
					recherche = {
						nom        : self.recherche_nom,
						recherche  : self.$store.state.filters.filters,
						pardefaut  : self.pardefaut,
						layers     : self.$store.getters.getLayersToSave,
						annotations: self.$store.getters.getAnnotationsForSave,
						email      : self.$store.state.user.user.email,
						area_report: area_report
					}
				}

				//As--> Ajout du centre de la carte et du zoom en cours
				recherche.display = {
					center : self.$store.state.ui.map_state.center,
					zoom   : self.$store.state.ui.map_state.zoom
				}

				//AS--> Enregistre la recherche
				self.$store.dispatch('send_recherche', recherche).then(function(response){
					self.succes  = true;
					let slug_name = JSON.parse(response.config.data).slug_name
					self.$store.commit('UI_SET_RECHERCHE_ID', recherche.nom)
					self.$store.dispatch('setSavedSearch', recherche)

					//AS--> Recharge les recherches dans le stores
					self.$store.dispatch('load_recherches')

					axios.post('api=inex/export/docx/{user_email}/{view_code}/'+slug_name, {})
						.then(function (response) {
							self.closeModale();
							self.$store.dispatch('open_modal', {
								code: 'pending_api', params: {
									promise: new Promise((resolve, reject) => {resolve(true)}),				
									success_title: 'rapport_zone_modal_success_title',
									success_message: 'rapport_zone_modal_success_message',					
								}
							})						
						}).catch(function (error) {
							let message = self.$t('rapport_zone_message_telechargement_erreur')
							if(error.response.status == 423){
								message = self.$t('rapport_zone_message_telechargement_erreur_telechargement_en_cours')
							}

							self.closeModale();
							self.$store.dispatch('add_toast', {
								message,
								type: 'error',
								icon: 'IconAttention',
								icon_viewBox: '0 0 24 24',
							})
						}).finally(function () {
							self.loading = false;
						})

				}).catch(function(error){
					self.succes  = false;
					self.erreur  = error.message ?? null;
					self.loading = false;

				}).finally(function(){
					self.encours = false
				})

			}
		},
		zoneGlobaleDispo(km){
			return this.largeur_zone_capture < km;
		},
		setZoneGlobale(km){
			if(this.zoneGlobaleDispo(km)){
				this.global_area_radius = km;
			}
		},
		closeModale(){
			this.$store.commit('UI_SET_MAP_OPTIONS_STREET_VIEW_CONTROL', true)
			this.$store.commit('UI_SET_MAP_OPTIONS_MAP_TYPE_ID', 'roadmap')
			this.$store.commit('UI_SET_MAP_OPTIONS_FULLSCREEN_CONTROL', true)
			if(document.fullscreenElement){
				this.$store.dispatch('toggle_full_screen')
			}
			this.$store.commit('UI_SET_MODALE_GAUCHE', null)
		},
		removeSelectedParcelles(){
			this.$store.commit('PARCELLE_SET_SELECTED_PARCELLES', [])
		}
	},
	computed:{

		// Calcul dynamiquement le rayon mini entre celui choisi dans l'interface et celui qui est disponible après zoom par le client
		// Garde toujours en mémoire le rayon sélectionné par le client et ne redescend jamais en dessous
		maxiGlobalRadius(){
			const valeursPossibles = [1, 2, 3, 5];
			const largeur = this.largeur_zone_capture || 0;
			const borneMin = this.global_area_radius || 1;
			
			// Trouve la première valeur qui respecte toutes les contraintes
			return valeursPossibles.find(val => val > largeur && val >= borneMin) || 5;
		},
		hasSelectedParcelles(){
			return this.$store.getters.getSelectedParcellesIds.length > 0;
		},
		hasParcellesSelectedInArea(){
			let parcelles_selected = this.$store.getters.getSelectedParcelles;
			let map_bounds_report = this.$store.state.ui.map_bounds_report
			const boundsPolygon = turf.bboxPolygon([
				map_bounds_report.west, map_bounds_report.south, map_bounds_report.east, map_bounds_report.north
			]);
			let result = true;
			parcelles_selected.features.forEach(parcelle => {
				const intersects = turf.booleanIntersects(parcelle, boundsPolygon);
				const isWithin = turf.booleanWithin(parcelle, boundsPolygon);
				if(!intersects && !isWithin){
					result = false;
				}				
			});
			return result
		}
	},
	components:{
		ModaleGauche,
		LoadingBtn,
		FieldAdresse,
		CustomInput,
		DrawingModes,
		Onglets
	}
}